import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
export function MathText({ children, className = '' }: { children: string; className?: string }) {
  return <div className={`prose ${className}`}><ReactMarkdown remarkPlugins={[remarkMath]} rehypePlugins={[rehypeKatex]} components={{ a: ({ children, ...props }) => <a {...props} target={props.href?.startsWith('#') ? undefined : '_blank'} rel={props.href?.startsWith('#') ? undefined : 'noreferrer'}>{children}</a> }}>{children}</ReactMarkdown></div>;
}
